import { useEffect, useState } from "react";
import { openNotificationError } from "./utils/Utils";

export default function NotificationInterceptor() {
  const [queue, setQueue] = useState([]);

  useEffect(() => {
    const originalAlert = window.alert;

    window.alert = function (message) {
      if (
        message !== "Uploading feature not available. miss file_upload_handler."
      ) {
        setQueue((prev) => [...prev, message]);
      }
    };

    return () => {
      window.alert = originalAlert;
    };
  }, []);

  useEffect(() => {
    if (queue.length > 0) {
      const next = queue[0];

      openNotificationError(
        typeof next === "string" ? next : next?.message || String(next)
      );

      setQueue((prev) => prev.slice(1));
    }
  }, [queue]);

  return null;
}
